import { render, staticRenderFns } from "./fuzzySearch.template?vue&type=template&id=33de1f4e&lang=pug&"
import script from "./fuzzySearch.client?vue&type=script&lang=ts&"
export * from "./fuzzySearch.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33de1f4e')) {
      api.createRecord('33de1f4e', component.options)
    } else {
      api.reload('33de1f4e', component.options)
    }
    module.hot.accept("./fuzzySearch.template?vue&type=template&id=33de1f4e&lang=pug&", function () {
      api.rerender('33de1f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fuzzySearch/fuzzySearch.component.vue"
export default component.exports